import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {
  static targets = [
    'dropzone',
    'input',
    'mainImageTemplate',
    'mainImageWrapper',
    'placeholderThumbnails',
    'preview',
    'thumbnails',
    'thumbnailTemplate'
  ]

  static values = {
    documentType: String
  }

  connect() {
    window.duc = this
    if (!this.hasInputTarget) { return }

    this.inputTarget.addEventListener('change', this.uploadFiles.bind(this))
    
    if (!this.hasDropzoneTarget) { return }

    this.dropzoneTarget.addEventListener('drop', this.uploadFiles.bind(this))
  }

  uploadFiles() {
    this.files = Array.from(this.inputTarget.files)
    this.files.forEach(file => this.uploadFile(file))
    this.inputTarget.value = null
  }

  uploadFile(file) {
    // your form needs the file_field direct_upload: true, which
    // provides data-direct-upload-url
    const url = this.inputTarget.dataset.directUploadUrl
    let blobURL = URL.createObjectURL(file)
    const upload = new DirectUpload(file, url)

    upload.create((error, blob) => {
      if (error) {
        // Handle the error
      } else {
        // Add an appropriately-named hidden input to the form with a
        //  value of blob.signed_id so that the blob ids will be
        //  transmitted in the normal upload flow
        const hiddenField = document.createElement('input')
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("value", blob.signed_id);
        hiddenField.name = this.inputTarget.name
        this.element.appendChild(hiddenField)

        // if (this.documentTypeValue) {
        //   console.log(this.documentTypeValue)
        //   const hiddenField = document.createElement('input')
        //   hiddenField.setAttribute("type", "hidden");
        //   hiddenField.setAttribute("value", this.documentTypeValue);
        //   hiddenField.name = ''
        //   this.element.appendChild(hiddenField)
        // }

        // remove placeholder
        if (this.hasPlaceholderThumbnailsTarget) {
          this.placeholderThumbnailsTarget.classList.add('hidden')
        }

        // show preview
        if (this.hasMainImageTemplateTarget && this.hasThumbnailTemplateTarget) {
          if (file == this.files[0]) {
            let newNode = this.mainImageTemplateTarget.content.cloneNode(true)
            newNode.querySelector('img').setAttribute('src', blobURL)
            this.mainImageWrapperTarget.appendChild(newNode)
          } else {
            let newNode = this.thumbnailTemplateTarget.content.cloneNode(true)
            newNode.querySelector('img').setAttribute('src', blobURL)
            this.thumbnailsTarget.appendChild(newNode)
          }
        }
      }
    })
  }

  disconnect() {
    this.inputTarget.removeEventListener('change', this.uploadFiles.bind(this))
  }
}
